import { render, staticRenderFns } from "./Create-Lead.vue?vue&type=template&id=5a2d74e6"
import script from "./Create-Lead.vue?vue&type=script&lang=js"
export * from "./Create-Lead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports